module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-13.bfb04196.JPG";